import React from "react";

const Navbar = props => {
  return (
    <header className="navbar">
      <h1 className="navTitle">Crystal Clicky Game</h1>
    </header>
  )
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar/Navbar.js